import { render } from "./IconPickerComponent.vue?vue&type=template&id=e8daa78e&scoped=true"
import script from "./IconPickerComponent.vue?vue&type=script&lang=js"
export * from "./IconPickerComponent.vue?vue&type=script&lang=js"

import "./IconPickerComponent.vue?vue&type=style&index=0&id=e8daa78e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8daa78e"]])

export default __exports__